import React from "react";
import styled from "styled-components";
import { collection, addDoc } from "firebase/firestore";
import { db } from "./Firebase/firebase";
import { COLLECTIONS } from "./Firebase/Colection";
import { Link } from "react-router-dom";

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  background: #050505;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  box-sizing: border-box;
`;

const Card = styled.div`
  width: min(720px, 100%);
  background: #0e0e0f;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.4);
  font-family: "Inter", "DM Sans", sans-serif;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 12px;
`;

const Subtitle = styled.p`
  font-size: 18px;
  margin-bottom: 24px;
  color: rgba(255, 255, 255, 0.85);
`;

const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const Input = styled.input`
  width: 100%;
  padding: 14px 16px;
  font-size: 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  &:focus {
    outline: none;
    border-color: #67a5eb;
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 140px;
  padding: 14px 16px;
  font-size: 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  background: rgba(255, 255, 255, 0.04);
  color: #fff;
  resize: vertical;
  &:focus {
    outline: none;
    border-color: #67a5eb;
  }
`;

const SubmitButton = styled.button`
  margin-top: 8px;
  width: fit-content;
  padding: 12px 32px;
  background: linear-gradient(135deg, #ff9f1c, #ff6b35);
  color: #050505;
  font-weight: 700;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  font-size: 16px;
  transition: opacity 0.2s ease;
  &:hover {
    opacity: 0.85;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const Message = styled.p`
  margin-top: 6px;
  font-size: 15px;
  color: ${(props) => (props.success ? "#22c55e" : "#f97316")};
`;

const ReturnLink = styled(Link)`
  display: inline-flex;
  margin-top: 30px;
  padding: 10px 20px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  &:hover {
    border-color: white;
  }
`;

const SupportPage = () => {
  const [nom, setNom] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [status, setStatus] = React.useState("");

  const handleSubmit = async () => {
    if (!nom || !email || !message) {
      setStatus("Merci de renseigner tous les champs.");
      return;
    }
    setLoading(true);
    setStatus("");
    try {
      await addDoc(collection(db, COLLECTIONS.INSCALE), {
        nom,
        email,
        message,
        type: "support",
        createdAt: new Date().toISOString(),
      });
      setStatus("Message bien reçu, nous reviendrons vers vous rapidement.");
      setNom("");
      setEmail("");
      setMessage("");
    } catch (error) {
      console.error(error);
      setStatus("Erreur lors de l'envoi, merci de réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <Card>
        <Title>Support GeekVibz</Title>
        <Subtitle>
          Page dédiée à l’assistance de l’application GeekVibz.
        </Subtitle>
        <Form>
          <Input
            placeholder="Nom ou pseudo"
            value={nom}
            onChange={(e) => setNom(e.target.value)}
          />
          <Input
            placeholder="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextArea
            placeholder="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <SubmitButton type="button" onClick={handleSubmit} disabled={loading}>
            {loading ? "Envoi..." : "Envoyer"}
          </SubmitButton>
          {status && (
            <Message success={status.includes("bien reçu")}>{status}</Message>
          )}
        </Form>
      </Card>
    </Wrapper>
  );
};

export default SupportPage;
